/*
    Vanilla AutoComplete v0.1
    Copyright (c) 2019 Mauro Marssola
    GitHub: https://github.com/marssola/vanilla-calendar
    License: http://www.opensource.org/licenses/mit-license.php
*/
let VanillaCalendar = (function () {
    function VanillaCalendar(options) {
        function addEvent(el, type, handler) {
            if (!el) return
            if (el.attachEvent) el.attachEvent('on' + type, handler)
            else el.addEventListener(type, handler);
        }
        function removeEvent(el, type, handler) {
            if (!el) return
            if (el.detachEvent) el.detachEvent('on' + type, handler)
            else el.removeEventListener(type, handler);
        }
        let opts = {
            selector: null,
            datesFilter: false,
            pastDates: false,
            availableWeekDays: [],
            availableDates: [],
            disableDates: arrDisableDates ? arrDisableDates : [],
            date: new Date(),
            todaysDate: new Date(),
            button_prev: null,
            button_next: null,
            month: null,
            month_label: null,
            onSelect: (data, elem) => { },
            months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
            shortWeekday: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
        }
        for (let k in options) if (opts.hasOwnProperty(k)) opts[k] = options[k]

        let element = document.querySelector(opts.selector)
        if (!element)
            return

        const getWeekDay = function (day) {
            return ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'][day]
        }

        const createDay = function (date) {
            let newDayElem = document.createElement('div')
            let dateElem = document.createElement('span')
            // let dateElemInfo = document.createElement('div')
            dateElem.innerHTML = date.getDate()
            newDayElem.className = 'vanilla-calendar-date'
            // dateElemInfo.className = 'calendar-date-info';
            var formatDate = date.toLocaleDateString();
            //newDayElem.setAttribute('data-calendar-date', date)
            newDayElem.setAttribute('data-calendar-date', formatDate)

            let available_week_day = opts.availableWeekDays.filter(f => f.day === date.getDay() || f.day === getWeekDay(date.getDay()))
            let available_date = opts.availableDates.filter(f => f.date === (date.getFullYear() + '-' + String(date.getMonth() + 1).padStart('2', 0) + '-' + String(date.getDate()).padStart('2', 0)))

            let disable_date = opts.disableDates.filter(f => f.date === (date.getFullYear() + '-' + String(date.getMonth() + 1).padStart('2', 0) + '-' + String(date.getDate()).padStart('2', 0)))

            if (date.getDate() === 1) {
                newDayElem.style.marginLeft = ((date.getDay()) * 14.28 - 14.28) < 0 ? (6 * 14.28) + '%' : ((date.getDay()) * 14.28 - 14.28) + '%'
            }
            if (opts.date.getTime() <= opts.todaysDate.getTime() - 1 && !opts.pastDates) {
                newDayElem.classList.add('vanilla-calendar-date--disabled')
            } else {
                if (opts.datesFilter) {
                    if (available_week_day.length) {
                        newDayElem.classList.add('vanilla-calendar-date--active')
                        newDayElem.setAttribute('data-calendar-data', JSON.stringify(available_week_day[0]))
                        newDayElem.setAttribute('data-calendar-name', JSON.stringify(available_week_day[0].value))
                        newDayElem.setAttribute('data-calendar-status', 'active')
                    } else if (available_date.length) {
                        newDayElem.classList.add('vanilla-calendar-date--active')
                        //newDayElem.setAttribute('data-calendar-data', JSON.stringify(available_date[0]))
                        // newDayElem.setAttribute('data-calendar-data', '{"date":"' + available_date[0].date + '"}')
                        // newDayElem.setAttribute('data-calendar-s1', available_date[0].s_1)
                        // newDayElem.setAttribute('data-calendar-s2', available_date[0].s_2)
                        // newDayElem.setAttribute('data-calendar-s3', available_date[0].s_3)
                        // dateElemInfo.innerHTML = available_date[0].info
                        newDayElem.setAttribute('data-calendar-status', 'active')
                    } else {
                        newDayElem.classList.add('vanilla-calendar-date--disabled')
                    }
                } else {
                    if (disable_date.length) {
                        newDayElem.classList.add('vanilla-calendar-date--disabled')
                    } else {
                        newDayElem.classList.add('vanilla-calendar-date--active')
                        newDayElem.setAttribute('data-calendar-status', 'active')
                    }
                }
            }
            if (date.toString() === opts.todaysDate.toString()) {
                newDayElem.classList.add('vanilla-calendar-date--today')
            }

            newDayElem.appendChild(dateElem)
            // newDayElem.appendChild(dateElemInfo)
            opts.month.appendChild(newDayElem)
        }

        const removeActiveClass = function () {
            document.querySelectorAll('.vanilla-calendar-date--selected').forEach(s => {
                s.classList.remove('vanilla-calendar-date--selected')
            })
        }

        let reInit = false;
        const selectDate = function () {
            let activeDates = element.querySelectorAll('[data-calendar-status=active]')
            activeDates.forEach(date => {
                date.addEventListener('click', function (e) {
                    // MG.modal.init();
                    // if (e.target.classList.contains('js-modal')) {
                    //     MG.modal.open()
                    // }
                    if (this.classList.contains('vanilla-calendar-date--selected')) {
                        removeActiveClass()
                        return true;
                    }
                    removeActiveClass()
                    let datas = this.dataset
                    let data = {}
                    if (datas.calendarDate)
                        data.date = datas.calendarDate
                    if (datas.calendarData)
                        data.data = JSON.parse(datas.calendarData)
                    opts.onSelect(data, this)
                    this.classList.add('vanilla-calendar-date--selected')
                })
            })
        }

        const createMonth = function () {
            clearCalendar()
            let currentMonth = opts.date.getMonth()
            while (opts.date.getMonth() === currentMonth) {
                createDay(opts.date)
                opts.date.setDate(opts.date.getDate() + 1)
            }

            opts.date.setDate(1)
            opts.date.setMonth(opts.date.getMonth() - 1)
            opts.month_label.innerHTML = opts.months[opts.date.getMonth()] + ' ' + opts.date.getFullYear()
            selectDate()
        }

        const monthPrev = function () {
            opts.date.setMonth(opts.date.getMonth() - 1)
            createMonth()
        }

        const monthNext = function () {
            opts.date.setMonth(opts.date.getMonth() + 1)
            createMonth()
        }

        const clearCalendar = function () {
            opts.month.innerHTML = ''
        }

        const createCalendar = function () {
            document.querySelector(opts.selector).innerHTML = `
            <div class="vanilla-calendar-header">
                <button type="button" class="vanilla-calendar-btn" data-calendar-toggle="previous"><svg xmlns="http://www.w3.org/2000/svg" width="33" height="4" fill="none" viewBox="0 0 33 4"><path class="button__path" fill="#6D7C50" fill-rule="evenodd" d="M1.88.864H33V.17H.133L0 .838l7.22 2.987.266-.642L1.88.864Z" clip-rule="evenodd"/></svg></button>
                <div class="vanilla-calendar-header__label" data-calendar-label="month"></div>
                <button type="button" class="vanilla-calendar-btn" data-calendar-toggle="next"><svg xmlns="http://www.w3.org/2000/svg" width="33" height="4" fill="none" viewBox="0 0 33 4"><path class="button__path" fill="#6D7C50" fill-rule="evenodd" d="M31.12.864H0V.17h32.867L33 .838l-7.22 2.987-.266-.642L31.12.864Z" clip-rule="evenodd"/></svg></button>
            </div>
            <div class="vanilla-calendar-week"></div>
            <div class="vanilla-calendar-body" data-calendar-area="month"></div>
            `
        }
        const setWeekDayHeader = function () {
            document.querySelector(`${opts.selector} .vanilla-calendar-week`).innerHTML = `
                <span>${opts.shortWeekday[0]}</span>
                <span>${opts.shortWeekday[1]}</span>
                <span>${opts.shortWeekday[2]}</span>
                <span>${opts.shortWeekday[3]}</span>
                <span>${opts.shortWeekday[4]}</span>
                <span>${opts.shortWeekday[5]}</span>
                <span>${opts.shortWeekday[6]}</span>
            `
        }

        this.init = function () {
            createCalendar()
            opts.button_prev = document.querySelector(opts.selector + ' [data-calendar-toggle=previous]')
            opts.button_next = document.querySelector(opts.selector + ' [data-calendar-toggle=next]')
            opts.month = document.querySelector(opts.selector + ' [data-calendar-area=month]')
            opts.month_label = document.querySelector(opts.selector + ' [data-calendar-label=month]')

            opts.date.setDate(1)
            createMonth()
            setWeekDayHeader()
            addEvent(opts.button_prev, 'click', monthPrev)
            addEvent(opts.button_next, 'click', monthNext)
        }

        this.destroy = function () {
            removeEvent(opts.button_prev, 'click', monthPrev)
            removeEvent(opts.button_next, 'click', monthNext)
            clearCalendar()
            document.querySelector(opts.selector).innerHTML = ''
        }

        this.reset = function () {
            this.destroy()
            this.init()
        }

        this.set = function (options) {
            for (let k in options)
                if (opts.hasOwnProperty(k))
                    opts[k] = options[k]
            createMonth()
            //             this.reset()
        }

        this.init()
    }
    return VanillaCalendar
})()

window.VanillaCalendar = VanillaCalendar